import { ECompanyInfoRoute, IForecastDto } from '~/core/models'
import { SeoPage } from '~/core/services'

export const COMPANY_PAGE_SEO: Partial<
  Record<ECompanyInfoRoute, Omit<SeoPage, 'translationParams'>>
> = {
  [ECompanyInfoRoute.EARN]: {
    titleKey: 'seo.ticker.title',
    descriptionKey: 'seo.ticker.description',
    jsonLd: {
      type: 'WebPage',
      nameKey: 'seo.ticker.title',
      descriptionKey: 'seo.ticker.description',
    },
  },
  [ECompanyInfoRoute.STOCK_PREDICTIONS]: {
    titleKey: 'seo.tickerScenarios.title',
    descriptionKey: 'seo.tickerScenarios.description',
    jsonLd: {
      type: 'WebPage',
      nameKey: 'seo.tickerScenarios.title',
      descriptionKey: 'seo.tickerScenarios.description',
    },
  },
  [ECompanyInfoRoute.HISTORICAL_DATA]: {
    titleKey: 'seo.tickerHistory.title',
    descriptionKey: 'seo.tickerHistory.description',
    jsonLd: {
      type: 'WebPage',
      nameKey: 'seo.tickerHistory.title',
      descriptionKey: 'seo.tickerHistory.description',
    },
  },
  [ECompanyInfoRoute.COMPARABLE_COMPANIES]: {
    titleKey: 'seo.tickerComparables.title',
    descriptionKey: 'seo.tickerComparables.description',
    jsonLd: {
      type: 'WebPage',
      nameKey: 'seo.tickerComparables.title',
      descriptionKey: 'seo.tickerComparables.description',
    },
  },
  [ECompanyInfoRoute.EDGAR_REPORT]: {
    titleKey: 'seo.tickerEdgarReport.title',
    descriptionKey: 'seo.tickerEdgarReport.description',
    jsonLd: {
      type: 'Article',
      nameKey: 'seo.tickerEdgarReport.title',
      descriptionKey: 'seo.tickerEdgarReport.description',
    },
  },
}

export const COMPANY_PAGE_BREADCRUMB_LABELS: Partial<Record<ECompanyInfoRoute, string>> = {
  [ECompanyInfoRoute.EARN]: 'forecastInfo.tabs.commonForecast',
  [ECompanyInfoRoute.STOCK_PREDICTIONS]: 'forecastInfo.tabs.stockPricePredictions',
  [ECompanyInfoRoute.HISTORICAL_DATA]: 'forecastInfo.tabs.historicalData',
  [ECompanyInfoRoute.COMPARABLE_COMPANIES]: 'forecastInfo.tabs.peersCompanies',
  [ECompanyInfoRoute.EDGAR_REPORT]: 'forecastInfo.tabs.edgarReport',
}

export type CompanyBreadcrumb = {
  label: string
  path: string
  isCurrent: boolean
}

export const getCompanyBreadcrumbs = (
  forecast: IForecastDto,
  companyInfoRoute: ECompanyInfoRoute,
  translate: (key: string) => string
): CompanyBreadcrumb[] => {
  const ticker = forecast.company.ticker
  const tickerPath = `/${ticker}/${ECompanyInfoRoute.EARN}`
  const currentPath = `/${ticker}/${companyInfoRoute}`
  const breadcrumbs: CompanyBreadcrumb[] = [
    { label: translate('appMenu.home'), path: '/', isCurrent: false },
  ]

  if (companyInfoRoute === ECompanyInfoRoute.EARN) {
    breadcrumbs.push({ label: ticker, path: tickerPath, isCurrent: true })

    return breadcrumbs
  }

  breadcrumbs.push({ label: ticker, path: tickerPath, isCurrent: false })
  breadcrumbs.push({
    label: translate(
      COMPANY_PAGE_BREADCRUMB_LABELS[companyInfoRoute] ??
        COMPANY_PAGE_BREADCRUMB_LABELS[ECompanyInfoRoute.EARN]!
    ),
    path: currentPath,
    isCurrent: true,
  })

  return breadcrumbs
}
